/**
 * Tradução de textos por seção no Shopify.
 *
 * v3: substitui a v2. Cada REGRA tem seus próprios seletores e seu próprio
 * dicionário, então dá pra traduzir seções diferentes com termos diferentes
 * mantendo um único arquivo instalado no tema.
 *
 * Nada de value de <select>/<input> é alterado — só texto visível e atributos
 * de acessibilidade. Os filtros e formulários continuam funcionando.
 *
 * DICA para descobrir o ID de uma seção: abra a página, F12 → Console e cole:
 *
 *   [...document.querySelectorAll('[id^="shopify-section"]')]
 *     .filter(s => /shop now/i.test(s.textContent))
 *     .map(s => "'#" + s.id + "',").join('\n')
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // CONFIGURAÇÃO
  // ---------------------------------------------------------------------------

  var RULES = [
    {
      nome: 'Seletor de veículo',
      targets: [
        '#shopify-section-template--27304675901743__17861247840733b5d7',
        '#shopify-section-template--27364375134511__17861247840733b5d7'
      ],
      dict: {
        'YEAR': 'ANO',
        'MAKE': 'MARCA',
        'MODEL': 'MODELO',
        'SUBMODEL': 'SUBMODELO',
        'ENGINE': 'MOTOR',
        'ANY': 'QUALQUER'
      }
    },

    {
      nome: 'Lista de coleções',
      targets: [
        '#shopify-section-template--27304675901743__collection_list_EHPaRF'
        // Alternativa que pega todas as listas de coleção do site de uma vez:
        // '.collection-list'
      ],
      dict: {
        'SHOP NOW': 'COMPRAR'

        // Se quiser traduzir também o aria-label dos cards
        // ("Go to collection 'X' page"), descomente:
        // , 'GO TO COLLECTION': 'IR PARA A COLEÇÃO'
        // , 'PAGE': 'PÁGINA'
      }
    }
  ];

  var ATTRS = ['placeholder', 'aria-label', 'title', 'alt', 'data-placeholder', 'label'];

  // ---------------------------------------------------------------------------

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, SVG: 1, TEMPLATE: 1 };

  var regras = [];       // { selector, dict, re, roots: [{el, observer}] }
  var applying = false;
  var rescanQueued = false;

  function escapeRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Constrói o regex do dicionário. Chaves maiores primeiro (SUBMODEL antes de
  // MODEL) e espaços viram \s+ para tolerar quebras de linha do Liquid.
  function montarRegex(dict) {
    var keys = Object.keys(dict).sort(function (a, b) { return b.length - a.length; });
    var partes = keys.map(function (k) {
      return escapeRe(k).replace(/\s+/g, '\\s+');
    });
    return new RegExp('(?<![\\w-])(' + partes.join('|') + ')(?![\\w-])', 'gi');
  }

  function matchCase(original, translated) {
    if (original === original.toUpperCase()) return translated.toUpperCase();
    if (original === original.toLowerCase()) return translated.toLowerCase();
    return translated.charAt(0).toUpperCase() + translated.slice(1).toLowerCase();
  }

  function traduzir(regra, text) {
    return text.replace(regra.re, function (m) {
      // normaliza espaços internos para achar a chave no dicionário
      var chave = m.replace(/\s+/g, ' ').toUpperCase();
      var alvo = regra.dict[chave];
      if (!alvo) return m;
      return matchCase(m, alvo);
    });
  }

  function traduzirTextNodes(regra, root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var parent = node.parentNode;
        if (parent && SKIP_TAGS[parent.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      var novo = traduzir(regra, node.nodeValue);
      if (novo !== node.nodeValue) node.nodeValue = novo;
    }
  }

  function traduzirAtributos(regra, root) {
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];

      for (var j = 0; j < ATTRS.length; j++) {
        var attr = ATTRS[j];
        var val = el.getAttribute(attr);
        if (!val) continue;
        var novo = traduzir(regra, val);
        if (novo !== val) el.setAttribute(attr, novo);
      }

      // value só em botões, nunca em campo de texto/select.
      if (el.tagName === 'INPUT' && /^(button|submit|reset)$/i.test(el.type) && el.value) {
        var nv = traduzir(regra, el.value);
        if (nv !== el.value) el.value = nv;
      }
    }
  }

  // <option> com texto vazio e rótulo no atributo label (alguns apps fazem isso).
  function traduzirOptions(regra, root) {
    var opts = root.querySelectorAll('option');
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      if (!o.textContent.trim() && o.label) {
        var novo = traduzir(regra, o.label);
        if (novo !== o.label) o.label = novo;
      }
    }
  }

  function aplicar(regra, root) {
    if (applying) return;
    applying = true;
    try {
      traduzirTextNodes(regra, root);
      traduzirAtributos(regra, root);
      traduzirOptions(regra, root);
    } finally {
      // Descarta as mutações causadas pelo próprio script, em todas as regras.
      for (var i = 0; i < regras.length; i++) {
        for (var j = 0; j < regras[i].roots.length; j++) {
          regras[i].roots[j].observer.takeRecords();
        }
      }
      applying = false;
    }
  }

  function registrar(regra, el) {
    for (var i = 0; i < regra.roots.length; i++) {
      if (regra.roots[i].el === el) return;
    }

    var observer = new MutationObserver(function () {
      if (applying) return;
      aplicar(regra, el);
    });

    regra.roots.push({ el: el, observer: observer });

    aplicar(regra, el);

    observer.observe(el, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRS
    });
  }

  function varrer() {
    for (var i = 0; i < regras.length; i++) {
      var regra = regras[i];
      if (!regra.selector) continue;

      // Descarta seções que saíram do DOM.
      regra.roots = regra.roots.filter(function (r) {
        if (document.contains(r.el)) return true;
        r.observer.disconnect();
        return false;
      });

      var achados = document.querySelectorAll(regra.selector);
      for (var k = 0; k < achados.length; k++) registrar(regra, achados[k]);
    }
  }

  function agendarVarredura() {
    if (rescanQueued) return;
    rescanQueued = true;
    requestAnimationFrame(function () {
      rescanQueued = false;
      varrer();
    });
  }

  function iniciar() {
    for (var i = 0; i < RULES.length; i++) {
      var r = RULES[i];
      if (!r.targets || !r.targets.length || !r.dict) continue;
      regras.push({
        nome: r.nome || ('regra ' + i),
        selector: r.targets.join(','),
        dict: r.dict,
        re: montarRegex(r.dict),
        roots: []
      });
    }

    varrer();

    // Seções que chegam depois (AJAX, lazy load, navegação sem reload).
    new MutationObserver(function () {
      if (applying) return;
      agendarVarredura();
    }).observe(document.documentElement, { childList: true, subtree: true });

    // Editor de temas do Shopify.
    document.addEventListener('shopify:section:load', agendarVarredura);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();